export default __webpack_public_path__ + "static/media/body-1.3706ee48.png";